export default {
  CREATE: `Create a punch rule`,
  DELETE_BUTTON: {
    TITLE: `Delete the punch rule`,
    SUMMARY: `Are you sure you want to delete this punch rule?`,
    PRIMARY_ACTION: `Delete the punch rule`
  },
  LIST: {
    TITLE: `Punch rules list`,
    SUMMARY: ``
  },
  form: {
    CREATE: {
      TITLE: `Creating a punch rule`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a punch rule`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Punch rule name`,
      DESCRIPTION: `This name should help you quickly identify the punch rule.`,
      PLACEHOLDER: `Enter a name for the punch rule`
    },
    OVERTIME_RULES: `Overtime rules`,
    OVERTIMEWAGEPREMIUMID: { LABEL: `Wage Premium`, DESCRIPTION: `` },
    OVERTIMETHRESHOLDDAY: {
      LABEL: `Daily threshold`,
      DESCRIPTION: `Punch cards with more than this number of hours will automatically have exceeding hours changed to overtime.`,
      PLACEHOLDER: `Enter a value between 0 and 24`
    },
    OVERTIMETHRESHOLDWEEK: {
      LABEL: `Weekly threshold`,
      DESCRIPTION: `The last modified punch card in a weekly period will have the hours exceeding this value changed to overtime.`,
      PLACEHOLDER: `Enter a value between 0 and 168`
    },
    NAME_REQUIRED: `Punch rule's name is mandatory.`,
    TRANSFER_RULES: `Transfer rounding`,
    BREAK_RULES: `Break rounding`,
    AUTO_APPROVED_ARRIVAL: `Arrival automatically approved`,
    AUTO_APPROVED_LEAVE: `Departure automatically approved`,
    DANGER_START_RULE: `All other arrival punch times will be flagged and will need to be approved. When manually approved  `,
    DANGER_END_RULE: `All other departure punch times will be flagged and will need to be approved. When manually approved  `,
    ROUND_5: `and round to nearest 5 minutes`,
    ROUND_15: `and round to nearest 15 minutes`,
    TO_SHIFT: `and round to shift time`,
    NO_ROUND: `and do not round`,
    MIN_BEFORE_START: ` minutes before shift start `,
    MIN_AFTER_START: ` minutes after shift start `,
    MIN_BEFORE_END: ` minutes before shift end `,
    MIN_AFTER_END: ` minutes after shift end `,
    dangerRounding: {
      ROUND_5: ` round to nearest 5 minutes`,
      ROUND_15: `round to nearest 15 minutes`,
      TO_SHIFT: `round to shift time`,
      NO_ROUND: `do not round`
    }
  },
  TRANSFER_ACTION: `Transfer`,
  BREAK_ACTION: `Break`,
  ROUND_5: `Round to nearest 5 minutes`,
  ROUND_15: `Round to nearest 15 minutes`,
  TO_SHIFT: `Round to shift time`,
  NO_ROUND: `Do not round`
}
